import { IBullhornCandidate } from '../interfaces/bullhornCandidate';
import { axiosAdmin } from './axios';

export namespace BullhornService {
  const baseUrl = '/bullhorn';

  export function lookup(customerId: number, email: string): Promise<IBullhornCandidate> {
    return axiosAdmin.get<IBullhornCandidate>(baseUrl + '/candidates/lookup', { params: { customerId, email } })
      .then(({ data }) => data);
  }
}